//대시보드
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import { Body2, Sub2 } from "../../../assets/styles/Typography";
import { Button } from "../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import { useAtom } from "jotai";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DISPLAY_LIST,
  AUTODISPLAY_CONTENT_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  SELECTED_CUSTOMER_TYPE,
  CUSTOMER_DETAIL,
  AUTODISPLAY_SELECTED_CONTENT_ID,
} from "../../AtomStates";
import PopupWrap from "../../../assets/styles/Popup";
import {
  createDisplayOnServer,
  updateDisplayOnServer,
  getDisplayListOnServer,
  getDisplayListCustomerOnServer,
  getViewApiListOnServer,
  getViewCustomListOnServer,
  getViewApiListCustomerOnServer,
  getViewCustomListCustomerOnServer,
  getUserInfo,
  getUserMemberType,
  updateCustomerOnServer,
  getCustomerDetailOnServer,
  getEduTimetableLotationDetailOnServer,
  getDeviceListOnServer,
} from "../../../utils/indexedDB";
import AutodisplayApiSelectedPopup from "../components/molecules/AutodisplayApiSelectedPopup";
import OrganismInfoDeviceList from "../components/organisms/OrganismInfoDeviceList";

const PageDashBoardInfoBoard = () => {
  const navigate = useNavigate();
  // 팝업 관련 상태
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [addDisplayForm, setAddDisplayForm] = useState({
    deviceTitle: "",
    deviceLocation: "",
    deviceTarget: "",
    deviceSpec: {
      deviceWidth: "",
      deviceHeight: "",
      deviceWidthMM: "",
      deviceHeightMM: "",
      deviceCm: "",
      deviceResolution: "",
      deviceDPI: "",
      deviceInch: "",
    },
  });
  const [showDeviceSelectPopup, setShowDeviceSelectPopup] = useState(false);
  const [activateCount, setActivateCount] = useState(0);
  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [selectedEditDisplayId, setSelectedEditDisplayId] = useState(null);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);

  const [selectedCustomerType, setSelectedCustomerType] = useAtom(
    SELECTED_CUSTOMER_TYPE
  );
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [companyInfo, setCompanyInfo] = useState("");
  const [lotationDetail, setLotationDetail] = useState(null);

  // 고객사 정보를 불러오는 함수
  const fetchCustomerDetail = async () => {
    try {
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
      setCustomerId(customerIdFromStorage);
      if (customerIdFromStorage !== "") {
        const customerDetailResponse = await getCustomerDetailOnServer(
          customerIdFromStorage,
          isLoggedIn
        );
        if (customerDetailResponse) {
          setCustomerDetail(customerDetailResponse);
          setCompanyName(customerDetailResponse.companyName);
          setAddress(customerDetailResponse.address);
          setCompanyInfo(customerDetailResponse.companyInfo);
        }
      }
    } catch (error) {
      console.error("고객사 정보를 불러오는 중 오류가 발생했습니다:", error);
    }
  };

  const checkMemberType = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    const userMemberType = await getUserMemberType(accessToken);
    const lastUrl = sessionStorage.getItem("lastUrl");

    const currentUrl = window.location.href;
    sessionStorage.setItem("lastUrl", currentUrl);

    if (
      (lastUrl === "/InfoDashBoard" || lastUrl === "/CreateInfoDevice") &&
      userMemberType.member_type === 99 || userMemberType.emember_type >= 100
 
    ) {
      navigate("/Admin");
    }

    if (userMemberType.member_type === 11) {
      navigate("/DashBoard");
    } else if (userMemberType.member_type === 12) {
      navigate("/CustomerManage");
    } else if (userMemberType.member_type === 31) {
      navigate("/EducationDashBoard");
    } else if (userMemberType.member_type === 32) {
      navigate("/EduboardManage");
    }  else if (userMemberType.member_type === 41) {
      navigate("/InfoDashBoard");
    }  else if (userMemberType.member_type === 42) {
      navigate("/CustomerManageInfoBoard");
    } 
  };

  // 데이터 fetching 함수 분리
  const fetchContentList = async () => {
    if (!isLoggedIn) {
      return; // 로그인 상태가 아니면 API를 호출하지 않음
    }

    try {
      let response;
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";

      if (customerIdFromStorage === "" && memberType.member_type === 21) {
        response = await getDisplayListOnServer(10, 1, isLoggedIn);
        setDisplayList(response.data);
      } else {
        response = await getDisplayListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        setDisplayList(response.data);
      }

      let viewList;
      let viewListCustom;

      if (customerIdFromStorage === "") {
        viewList = await getViewApiListOnServer(10, 1, isLoggedIn);
        viewListCustom = await getViewCustomListOnServer(10, 1, isLoggedIn);
      } else {
        viewList = await getViewApiListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        viewListCustom = await getDeviceListOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
      }
      // 두 리스트 합치기
      const mergedList = [
        ...(viewList.data || []),
        ...(viewListCustom.data || []),
      ];
      // timestamp 내림차순 정렬 (최신순)
      mergedList.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      setActivateCount(viewList.activate_count + viewListCustom.activate_count);
      setContentList(mergedList);
    } catch (error) {
      console.error("콘텐츠 리스트를 불러오는 중 오류가 발생했습니다:", error);
    }
  };
  console.log("contentList", contentList);
  const fetchCompanyName = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    const userInfo = await getUserInfo(accessToken);
    if (customerId === "") {
      setCustomerName(userInfo.organization_name);
    }
  };

  const getLotationList = async () => {
    try {
      const customerId = sessionStorage.getItem("customerId");

      // 편성 데이터 로드
      const lotationDetailData = await getEduTimetableLotationDetailOnServer(
        customerId
      );
      setLotationDetail(lotationDetailData);
    } catch (error) {
      console.error("Error fetching lotation list:", error);
    } finally {
      // setIsTimetableLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        await checkMemberType();
        await getLotationList();
        await fetchContentList();
        await fetchCustomerDetail();
        await fetchCompanyName();
      } catch (error) {
        console.error("Error initializing:", error);
      } finally {
        // setIsTimetableLoading(false);
      }
    };
    init();
  }, []);

  // AutodisplaySelectedPopup에서 기기 선택 시
  const handleAutoDisplaySelect = (selectedDisplayId) => {
    const originalDevice = displayList.find((d) => d._id === selectedDisplayId);
    // console.log("originalDevice", originalDevice);
    if (originalDevice) {
      // setSelectedDevice(originalDevice);
      setShowDeviceSelectPopup(false);
      // navigate("/CreateContent", { state: { selectedDevice: originalDevice } });
    }
  };

  const handleAutoDisplayClose = () => {
    setShowDeviceSelectPopup(false);
    setSelectedEditDisplayId(null);
  };

  const handleSaveNewDisplay = async (displayData) => {
    try {
      // customerId가 있으면 displayData에 추가
      if (customerId !== "") {
        displayData.customer = customerId;
      }
      // 1. 먼저 새 디스플레이 ID를 생성
      const newDisplayId = await createDisplayOnServer(isLoggedIn);

      if (!newDisplayId) {
        throw new Error("디스플레이 ID 생성에 실패했습니다.");
      }

      // 2. 생성된 ID에 디스플레이 정보를 업데이트
      await updateDisplayOnServer(newDisplayId, displayData);

      // 3. 디스플레이 목록 새로고침
      await fetchContentList();
    } catch (error) {
      console.error("새 디스플레이 저장 실패:", error);
      throw error; // AutodisplaySelectedPopup에서 에러 처리하도록 전달
    }
  };

  // 사이즈 계산 로직
  useEffect(() => {
    const { deviceDPI, deviceInch } = addDisplayForm.deviceSpec;

    if (!deviceDPI || !deviceInch) return;

    try {
      const resolutionMatch = deviceDPI.match(/(\d{3,})\s*[×x*]\s*(\d{3,})/);
      const inchMatch = deviceInch.match(/(\d+(\.\d+)?)/);

      if (!resolutionMatch || !inchMatch) return;

      const widthPx = parseInt(resolutionMatch[1], 10);
      const heightPx = parseInt(resolutionMatch[2], 10);
      const diagonalInch = parseFloat(inchMatch[1]);

      const aspectRatio = widthPx / heightPx;
      const heightInch = diagonalInch / Math.sqrt(aspectRatio ** 2 + 1);
      const widthInch = heightInch * aspectRatio;

      const widthMm = Math.round(widthInch * 25.4);
      const heightMm = Math.round(heightInch * 25.4);

      setAddDisplayForm((prev) => ({
        ...prev,
        deviceSpec: {
          ...prev.deviceSpec,
          deviceWidth: widthPx.toString(),
          deviceHeight: heightPx.toString(),
          deviceWidthMM: widthMm.toString(),
          deviceHeightMM: heightMm.toString(),
        },
      }));
    } catch (e) {
      console.error("Failed to calculate display size", e);
    }
  }, [
    addDisplayForm.deviceSpec.deviceDPI,
    addDisplayForm.deviceSpec.deviceInch,
  ]);

  // 새 콘텐츠 클릭 시 리스트 뷰로 이동
  const handleNewDeviceClick = () => {
    navigate("/CreateInfoDevice");
  };

  const handleNewContentClick = () => {
    navigate("/InfoContentManageDashBoard");
  };



  const handleCustomerSubmit = async () => {
    try {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      let customerType;
      if (userMemberType.member_type === 22) {
        customerType = 2;
      } else if (userMemberType.member_type === 12) {
        customerType = 1;
      } else if (userMemberType.member_type === 99) {
        customerType = selectedCustomerType;
      }
      const data = {
        companyName: companyName,
        address: address,
        companyInfo: companyInfo,
        customerType: customerType,
      };

      await updateCustomerOnServer(customerId, data);

      setCustomerDetail(data);
    } catch (error) {
      console.error("고객사 등록에 실패했습니다:", error);
    } finally {
      setShowCustomerPopup(false);
    }
  };

  return (
    <>
      <DashboardContainer>
        <MoleculeHeader />
        <MainContent>
          <TopSection>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <CompanyInfo>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <CompanyName>
                    {customerDetail?.companyName || customerName}
                  </CompanyName>
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background: "#f7f8fa",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      color: "#666",
                      fontSize: "14px",
                      fontWeight: "500",
                      fontFamily: "Pretendard",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowCustomerPopup(true);
                      setCompanyName(customerDetail?.companyName || "");
                      setAddress(customerDetail?.address || "");
                      setCompanyInfo(customerDetail?.companyInfo || "");
                    }}
                  >
                    <EditIcon />
                    고객사 정보
                  </button>
                </div>
              </CompanyInfo>
              <Body2 color="gray600" style={{ textAlign: "left", marginLeft: 5, marginTop:10 }}>
                {customerDetail?.address}
              </Body2>
            </div>
            <ButtonGroup>

              <Button
                Large
                PrimaryLightest
                Fill
                onClick={handleNewContentClick}
                style={{ display: "inline-flex", alignItems: "center" }}
              >
              <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <circle cx="10" cy="10" r="1.5" fill="#256EF4" />
              <path
                d="m10 1 3 3-3 3-3-3 3-3zM10 19l3-3-3-3-3 3 3 3zM16 7l3 3-3 3-3-3 3-3zM4 13l3-3-3-3-3 3 3 3z"
                fill="#256EF4"
              />
            </svg>
                <Sub2 color="primary">콘텐츠 관리</Sub2>
              </Button>
              <Button
                Large
                Primary
                Fill
                onClick={handleNewDeviceClick}
                style={{ display: "inline-flex", alignItems: "center" }}
              >
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M9.99935 4.16669V15.8334M4.16602 10H15.8327"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <Sub2 color="white">기기 추가하기</Sub2>
              </Button>
            </ButtonGroup>
          </TopSection>

          {/* 통계 섹션 */}
          <StatsSection>
            <StatsGrid>
              <StatCard>
                <StatHeader>
                  <Body2 color="gray600">청정기 개수 </Body2>
                </StatHeader>
                <StatValue>
                 
                  <StatValue> {contentList.length} 개</StatValue>
                </StatValue>
              </StatCard>
            </StatsGrid>
          </StatsSection>
          <TableSection>
            <OrganismInfoDeviceList
              customerId={customerId}
              contentList={contentList}
              lotationDetail={lotationDetail}
              onLotationUpdate={async () => {
                // 편성 데이터가 업데이트되면 다시 로드
                try {
                  const updatedLotationDetail =
                    await getEduTimetableLotationDetailOnServer(customerId);
                  setLotationDetail(updatedLotationDetail);
                } catch (error) {
                  console.error("Error refreshing lotation detail:", error);
                }
              }}
            />
          </TableSection>
        </MainContent>

        {/* 기기 없음 알림 팝업 */}

        {/* 기기 선택 팝업 */}
        {showDeviceSelectPopup && (
          <AutodisplayApiSelectedPopup
            onClose={handleAutoDisplayClose}
            onSelect={handleAutoDisplaySelect}
            onSaveNewDisplay={handleSaveNewDisplay}
            selectedEditDisplayId={selectedEditDisplayId}
          />
        )}
      </DashboardContainer>
      {showCustomerPopup && (
        <PopupWrap
          TitleFlex
          title="고객사 정보"
          buttonType="Fill"
          confirmText={"편집 내용 저장"}
          isModal={true}
          onCancel={() => setShowCustomerPopup(false)}
          onConfirm={handleCustomerSubmit}
          showTabs={true}
          eventState={false}
          creditRequestCustomPersona={100}
          isFormValid={
            !!companyName &&
            !!address &&
            (companyName !== customerDetail?.companyName ||
              address !== customerDetail?.address ||
              companyInfo !== customerDetail?.companyInfo)
          }
          body={
            <div>
              <>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    고객사 명
                  </Body2>
                  <PopupContent>
                    <InputBox>
                      <InputText
                        placeholder="입력해주세요."
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </InputBox>
                  </PopupContent>
                </div>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    주소지
                  </Body2>
                  <PopupContent>
                    <InputBox>
                      <InputText
                        placeholder="입력해주세요."
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </InputBox>
                  </PopupContent>
                </div>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    고객사 관련 정보{" "}
                  </Body2>
                  <PopupContent>
                    <InputBox2>
                      <InputTextArea
                        value={companyInfo}
                        onChange={(e) => setCompanyInfo(e.target.value)}
                        placeholder="입력해주세요."
                        rows={4}
                      />
                    </InputBox2>
                  </PopupContent>
                </div>
              </>
            </div>
          }
        />
      )}
    </>
  );
};

export default PageDashBoardInfoBoard;

// PopupContent 스타일 추가
export const PopupContent = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

// 스타일 컴포넌트들
const DashboardContainer = styled.div`
  width: 100%;
  max-width: 2330px;
  margin: 0 auto;
  background: ${palette.white};
  min-height: 100vh;
`;

const MainContent = styled.main`
  max-width: 1240px;
  margin: 0 auto;
  padding: 145px 0;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const CompanyName = styled.h2`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 32px;
  color: #1e2124;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
  margin-top: -40px;
`;

const StatsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: -40px;
`;

const StatsGrid = styled.div`
  display: flex;
  gap: 20px;
`;

const StatCard = styled.div`
  flex: 0 0 calc(33.333% - 13.333px);
  background: ${palette.white};
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StatValue = styled.div`
  font-family: Poppins;
  font-weight: 700;

  font-size: 30px;
  color: #666666;
  text-align: left;
`;

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9124 4.12883C22.329 3.71227 23.0044 3.71227 23.4209 4.12883L28.7542 9.46216C28.9543 9.6622 29.0667 9.93351 29.0667 10.2164C29.0667 10.4993 28.9543 10.7706 28.7542 10.9707L16.7542 22.9707C16.5542 23.1707 16.2829 23.2831 16 23.2831H10.6667C10.0776 23.2831 9.6 22.8055 9.6 22.2164V16.8831C9.6 16.6002 9.71238 16.3289 9.91242 16.1288L21.9124 4.12883ZM22.6667 6.39157L20.1752 8.88307L24 12.7079L26.4915 10.2164L22.6667 6.39157ZM22.4915 14.2164L18.6667 10.3916L11.7333 17.3249V21.1497H15.5582L22.4915 14.2164ZM6.4 7.01641C6.25272 7.01641 6.13333 7.1358 6.13333 7.28307V26.4831C6.13333 26.6303 6.25272 26.7497 6.4 26.7497H25.6C25.7473 26.7497 25.8667 26.6303 25.8667 26.4831V17.1497C25.8667 16.5606 26.3442 16.0831 26.9333 16.0831C27.5224 16.0831 28 16.5606 28 17.1497V26.4831C28 27.8086 26.9255 28.8831 25.6 28.8831H6.4C5.07452 28.8831 4 27.8086 4 26.4831V7.28307C4 5.95759 5.07452 4.88307 6.4 4.88307H15.7323C16.3214 4.88307 16.799 5.36064 16.799 5.94974C16.799 6.53884 16.3214 7.01641 15.7323 7.01641H6.4Z"
      fill="#8A949E"
    />
  </svg>
);

const InputBox = styled.div`
  height: 56px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const InputBox2 = styled.div`
  height: 150px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

const InputText = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  &::placeholder {
    color: ${palette.gray300};
  }
`;

const InputTextArea = styled.textarea`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  padding-top: 16px;
  resize: vertical;
  &::placeholder {
    color: ${palette.gray300};
  }
`;
